import styled from "styled-components";

export const RadioMultiCheckBoxStyled = styled.div`
  .label {
    margin-bottom: 8px;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  }
  .radio_row {
    .radio_item {
      margin-bottom: 14px;
      display: flex;
      align-items: center;
      cursor: pointer;
      .custom_radio {
        position: relative;
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
        border-radius: 50%;
        background: #fff;
        margin-right: 10px;
        &:after {
          content: "";
          width: 12px;
          height: 12px;
          background: ${({ theme }) => theme.COLORS.PURPLE_1};
          border-radius: 50%;
          position: absolute;
          top: 50%;
          left: 50%;
          opacity: 0;
          transform: translate(-50%, -50%) scale(0);
          transition: all 0.2s ease;
        }
      }
      &.checked .custom_radio:after {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
      }
      .custom_label {
        color: ${({ theme }) => theme.COLORS.BLACK_4};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      }
    }
  }

  .errors {
    margin-top: 2px;
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    color: ${({ theme }) => theme.COLORS.RED_1};
  }

  .theme_standard {
  }

  .theme_horizontal {
    .radio_row {
      display: flex;
      .radio_item {
        flex: 1;
      }
    }
  }

  .theme_question {
    .label {
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    }
  }

  .theme_bosendorfer {
    .radio_row {
      .radio_item {
        .custom_radio {
          border-color: ${({ theme }) => theme.COLORS.GOLD_2};
          &:after {
            background: ${({ theme }) => theme.COLORS.GOLD_2};
          }
        }
        .custom_label {
          color: ${({ theme }) => theme.COLORS.GOLD_2};
          font-size: ${({ theme }) => theme.FONT.SIZE.S16};
          font-family: ${({ theme }) => theme.FONT.STYLE.BRANDON_REGULAR};
        }
      }
    }
  }

  .theme_purple {
    .radio_row {
      .radio_item {
        .custom_label {
          color: ${({ theme }) => theme.COLORS.PURPLE_1};
        }
      }
    }
  }
`;
